export const config = {
  title: "Soti Construction",
  meta: {
    description:
      "Soti Construction offers expert concrete, landscaping, and excavation services in Salt Lake City, UT. Built on generations of craftsmanship and trust.",
    keywords: [
      "Concrete Contractor Salt Lake City",
      "Driveways and Patios",
      "Landscaping Services",
      "Excavation Services",
      "Soti Construction",
      "Utah Construction Services"
    ],
    author: "Soti Construction",
    canonicalUrl: "https://soticonstruction.com/",
  },
  sections: {
    header: {
      businessName: "Soti Construction",
    },
    sectionB: {
      heroTitle: "Soti Construction",
      heroSubtitle: "Expert Concrete & Excavation Services in Salt Lake City",
      learnAboutText: "Explore Our Services",
      phoneNumber: "8018543299",
      phoneLabel: "(801) 854-3299",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/530746094/photo/construction-worker.jpg?s=612x612&w=0&k=20&c=qMfHBHTKVwbX10VuAlZIDukuB7w9bX5BMSJWbgvVvQ4=",
      cardData: [
        {
          title: "Concrete Solutions",
          description:
            "From driveways to decorative finishes, we deliver durable and aesthetic concrete work.",
        },
        {
          title: "Landscaping Services",
          description:
            "Enhance your outdoor space with our comprehensive landscaping solutions.",
        },
        {
          title: "Excavation Expertise",
          description:
            "Professional excavation services for foundations, drainage, and site preparation.",
        },
      ],
      description:
        "At Soti Construction, we combine skill, speed, and precision to deliver concrete, landscaping, and excavation services that stand the test of time. Serving Salt Lake City and surrounding areas.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Discover our range of construction services tailored to meet your project's needs.",
      cards: [
        {
          title: "Concrete Work",
          description:
            "Expert concrete services including driveways, patios, foundations, and decorative finishes.",
          imageSrc: "https://media.istockphoto.com/id/1178532968/photo/man-worker-standing-on-scaffolding-and-restore-old-building-facade.jpg?s=612x612&w=0&k=20&c=WpWX7pqhUDWa4PBVPm1jp0P54j5NJMQkrQcI94RkyRo=",
          imageAlt: "Concrete Work",
        },
        {
          title: "Landscaping",
          description:
            "Transform your outdoor space with our professional landscaping design and installation.",
          imageSrc: "https://media.istockphoto.com/id/1324918160/photo/professional-gardener-trimming-hedge.jpg?s=612x612&w=0&k=20&c=zumBbqam7P2pNpoGMrca4RhZGWW7zfRDUDE2zqABJTs=",
          imageAlt: "Landscaping Services",
        },
        {
          title: "Excavation",
          description:
            "Reliable excavation services for residential and commercial projects.",
          imageSrc: "https://media.istockphoto.com/id/1287874597/photo/excavator-dig-trench-at-forest-area-on-amazing-sunset-background.jpg?s=612x612&w=0&k=20&c=fiEwPU7Gt4np44YQGtIYD0GmHbexLwXMExkpE7iaICY=",
          imageAlt: "Excavation Services",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Decorative Concrete Finishes",
        "Walkout Basements",
        "R.V. Pads",
        "Site Leveling",
        "Drainage Solutions",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://cdn.commoninja.com/asset/1126cd39-5ae2-4a97-ac78-be9b4ee50d0c.png",
        alt: "Soti Construction Team",
      },
      aboutText: [
        "Soti Construction is a family-owned business rooted in generations of craftsmanship. With over 20 years of personal experience, we are committed to delivering quality construction services that exceed expectations.",
        "Our team values trust, precision, and customer satisfaction, ensuring every project is completed with the highest standards.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Soti Construction Logo",
      businessName: "Soti Construction",
      contact: {
        phone: "8018543299",
        phoneLabel: "(801) 854-3299",
        email: "info.soticonstruction@gmail.com",
        website: "https://soticonstruction.com/",
        address: "Salt Lake City, UT",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "Salt Lake City, UT",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3105.00123456789!2d-111.8910!3d40.7608!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x874d8a1234567890%3A0xabcdef1234567890!2sSalt%20Lake%20City%2C%20UT!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus",
    },
  },
};

export default config;
